import { takeEvery } from 'redux-saga/effects';

import * as ownerPageActions from 'store/modules/hostPage';

import { loadFeaturedVehicles } from './utils';

export default function* listenLoadFeaturedVehicles() {
  yield takeEvery(ownerPageActions.loadFeaturedVehicles.toString(), loadFeaturedVehicles);
}
